var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 83.741,
    viewBox: "0 0 74 83.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(-4969.65 -3160.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(4969.65 3160.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M5040.379,3264.508q-6.163,0-12.326,0a6.034,6.034,0,0,1-6.389-6.144q-.138-11.947,0-23.9a6.049,6.049,0,0,1,6.394-6.138q12.174-.024,24.351,0c4.229.011,6.715,2.544,6.712,6.743q-.006,11.273,0,22.546c0,4.418-2.473,6.889-6.868,6.893-2,0-4.008-.008-6.013-.011q-2.93,0-5.861,0Zm4.6-16.307a13.223,13.223,0,0,0,2.546-.036c.767-.162,1.876-.44,2.094-.973.23-.562-.4-1.487-.682-2.243a1.468,1.468,0,0,0-.393-.451c-2.331-2.268-4.626-4.577-7.038-6.759a2.039,2.039,0,0,0-1.935-.206c-2.781,2.59-5.515,5.239-8.109,8.015-1.127,1.208-.432,2.5,1.273,2.641,1.021.083,2.055.017,3.188.017,0,2.027-.013,3.822,0,5.617.015,1.61.655,2.237,2.291,2.253,1.4.014,2.8,0,4.206-.011,1.827-.016,2.522-.691,2.549-2.531C5045,3251.838,5044.983,3250.14,5044.983,3248.2Z",
    transform: "translate(-4985.123 -3180.812)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M5038.6,3201.576h-3.987c0-1.6,0-3.183,0-4.766,0-2.006-.034-4.011,0-6.017.014-.908-.349-1.257-1.25-1.232-1.5.042-3,.012-4.673.012v11.959h-4.322v-16.985c-.673-.03-1.16-.07-1.648-.071q-7.673-.007-15.343,0c-2.431,0-3.058-.628-3.06-3.127q-.007-7.295,0-14.59v-1.719h-30.233v64.816h25.235v4.337h-18.5c0,1.876-.014,3.517.006,5.158.011,1.075.836.947,1.522.949q7.445.013,14.892.005h2.064v4.053h-1.639c-5.113,0-10.231-.106-15.342.041-2.887.083-5.81-1.762-5.5-5.585.116-1.441.02-2.9.02-4.595-.934,0-1.771.006-2.606,0-3.213-.028-4.574-1.37-4.577-4.562q-.012-13.011,0-26.022,0-18.877,0-37.753c0-3.9,1.234-5.181,5.068-5.187,10.33-.015,20.658,0,30.986-.033a3.83,3.83,0,0,1,2.912,1.229q8.464,8.336,17,16.6c.957.931,2.311,1.683,2.786,2.81.484,1.143.107,2.649.107,4.271,1.71,0,3.25.106,4.769-.022a4.877,4.877,0,0,1,5.36,5.369C5038.454,3194.406,5038.6,3197.917,5038.6,3201.576Zm-17.217-21.436c-4.3-4.013-8.349-7.8-12.61-11.775v11.775Z",
    transform: "translate(-4969.649 -3160.659)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M5000.954,3213.676h-11.119c-.35,0-.7,0-1.052-.006-.921-.024-1.572-.407-1.58-1.409-.007-1.065.611-1.461,1.646-1.459q12.171.025,24.342,0c.984,0,1.689.239,1.711,1.371.023,1.221-.754,1.5-1.776,1.5Q5007.038,3213.672,5000.954,3213.676Z",
    transform: "translate(-4974.878 -3175.595)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M5004.506,3228.441c-5.336,0-10.586.037-15.831-.06a2.073,2.073,0,0,1-1.428-1.315c-.233-.9.448-1.5,1.386-1.542,1.148-.057,2.3-.022,3.453-.022,4.1,0,8.2,0,12.42,0Z",
    transform: "translate(-4974.878 -3179.971)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M4995.783,3198.888c-2.249,0-4.5-.016-6.746.006-1.044.011-1.809-.321-1.826-1.471-.02-1.176.774-1.485,1.8-1.483q6.9.012,13.792,0c1.017,0,1.832.263,1.824,1.459-.008,1.154-.752,1.5-1.8,1.495C5000.479,3198.874,4998.131,3198.888,4995.783,3198.888Z",
    transform: "translate(-4974.881 -3171.168)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M5004.592,3240.384v2.749a9.97,9.97,0,0,1-1.174.142c-4.751.01-9.505,0-14.257.011-1.142,0-2.1-.3-1.909-1.642a1.774,1.774,0,0,1,1.206-1.2C4993.8,3240.355,4999.136,3240.384,5004.592,3240.384Z",
    transform: "translate(-4974.886 -3184.406)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M4992.591,3181.228c1.3,0,2.606.033,3.907-.009.958-.032,1.552.513,1.422,1.31-.091.557-.807,1.415-1.282,1.44a78.9,78.9,0,0,1-8.107.018c-.468-.022-.894-.93-1.338-1.429.5-.438.949-1.175,1.5-1.256a26.889,26.889,0,0,1,3.9-.06Z",
    transform: "translate(-4974.875 -3166.777)",
    fill: "rgba(152,170,195,0.4)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.cc9fd1cfdf1acfbd278bd98642e236a8.svg";
export { ForwardRef as ReactComponent };